import React from "react";
import { useTranslation } from "react-i18next";
import { Package } from "@models/ISchema";
import { Pill, Tooltip } from "@foris/avocado-suite";
import SystemLabel from "@common/components/system-label";
import css from "./../GridSections/package.module.scss";
import headerCss from "../../../../common/components/Header/header.module.scss";

interface PackageHeaderSubtitleProps {
  packageData?: Package;
  headerDataAdapted?: any;
}

const PackageHeaderSubtitle = ({ packageData, headerDataAdapted }: PackageHeaderSubtitleProps) => {
  const { t } = useTranslation();

  return (
    <div className={headerCss.headerSubtitle}>
      <div className={css.headerPills}>
        <>
          <Pill textColor="gray-10" color="gray-70">
            {t("dimension.population.header.more-details.campus")}:{" "}
            {packageData?.population?.campus?.code}
          </Pill>
          <Pill textColor="gray-10" color="gray-70">
            {t("dimension.population.header.more-details.shift")}:{" "}
            {packageData?.population?.shift?.code}
          </Pill>
          <Pill textColor="gray-10" color="gray-70">
            {t("dimension.population.header.more-details.modality")}:{" "}
            {packageData?.population?.modality?.code}
          </Pill>
          <Pill textColor="gray-10" color="gray-70">
            {t("dimension.population.header.more-details.career")}:{" "}
            {packageData?.population?.program?.code}
          </Pill>
          <Pill textColor="gray-10" color="gray-70">
            {t("dimension.population.header.more-details.curriculum")}:{" "}
            {packageData?.population?.curriculum}
          </Pill>
          <Pill textColor="gray-10" color="gray-70">
            {t("dimension.population.header.more-details.level")}: {packageData?.population?.level}
          </Pill>
          <Pill textColor="gray-10" color="gray-70">
            {t("dimension.population.header.more-details.period")}:{" "}
            {packageData?.population?.term?.code}
          </Pill>
        </>

        {!!packageData?.isPublished && (
          <>
            <Tooltip
              label={t("dimension.package.header.published-package.tooltip")}
              placement="topLeft"
            >
              <Pill color="gray-70" textColor="gray-10" icon="check" iconColor="gray-10">
                {t("dimension.package.header.published-package.status")}
              </Pill>
            </Tooltip>

            <Pill
              color="gray-70"
              textColor="gray-10"
              icon={packageData?.isVisible ? "open-eye" : "closed-eye"}
              iconColor="gray-10"
            >
              {packageData?.isVisible
                ? t("dimension.package.header.published-package.visible")
                : t("dimension.package.header.published-package.no-visible")}
            </Pill>
          </>
        )}
      </div>
      {headerDataAdapted?.systemLabels?.length > 0 && (
        <div className={headerCss.headerSubtitle_systemLabels}>
          {headerDataAdapted?.systemLabels?.map(item => (
            <SystemLabel key={item?.id} label={item?.name} />
          ))}
        </div>
      )}
    </div>
  );
};

export default PackageHeaderSubtitle;
